/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var endpoints = {
    evaluate: "/api/featureflag/evaluation/flag",
    evaluateBulk: "/api/featureflag/evaluation/bulk",
};

function getFetch() {
    return typeof window !== "undefined" ? window.fetch : require("node-fetch");
}
var callEvaluate = function (config, logger, flagName) { return __awaiter(void 0, void 0, void 0, function () {
    var origin, body, result, response, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                origin = config.origin, body = config.body;
                result = null;
                return [4 /*yield*/, getFetch()("".concat(origin).concat(endpoints.evaluate, "/").concat(flagName), {
                        method: "POST",
                        body: JSON.stringify(body),
                        headers: {
                            accept: "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                json = _a.sent();
                if (response.status === 200) {
                    result = json === null || json === void 0 ? void 0 : json.result;
                }
                else if (response.status === 204) {
                    logger.info("Flag name: ".concat(flagName, " is disabled."));
                }
                else if (response.status === 400) {
                    logger.error("Flag name: ".concat(flagName, " did not return a result with the provided context. body: ").concat(JSON.stringify(json)));
                }
                else if (response.status === 404) {
                    logger.error("Flag name: ".concat(flagName, " could not be found!  body: ").concat(JSON.stringify(json)));
                }
                else if (response.status === 410) {
                    logger.error("Flag name: ".concat(flagName, " has been deleted!   body: ").concat(JSON.stringify(json)));
                }
                else {
                    logger.error("Unexpected Error Response received from feature flag service\nResponse status: ".concat(response.status, "\nResponse Body: ").concat(JSON.stringify(json)));
                }
                return [2 /*return*/, result];
        }
    });
}); };
var callBulkEvaluate = function (config, logger, options) { return __awaiter(void 0, void 0, void 0, function () {
    var origin, body, params, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                origin = config.origin, body = config.body;
                params = new URLSearchParams(options);
                return [4 /*yield*/, getFetch()("".concat(origin).concat(endpoints.evaluateBulk, "?").concat(params.toString()), {
                        method: "POST",
                        body: JSON.stringify(body),
                        headers: {
                            accept: "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if (response.status === 200) {
                    return [2 /*return*/, response.json()];
                }
                else if (response.status === 400) {
                    logger.error("Bad request, bulk evaluation was unsuccessful due to: ".concat(response.statusText));
                }
                else if (response.status === 404) {
                    logger.error("Requested tag ".concat(options.tag, " was not found"));
                }
                else {
                    logger.error("Unexpected response received from bulk evaluation.  Status: [".concat(response.status, "] status text: ").concat(response.statusText));
                }
                return [2 /*return*/, Promise.resolve({})];
        }
    });
}); };

var debug = console.debug, info = console.info, warn = console.warn, error = console.error;
var defaultLogger = { debug: debug, info: info, warn: warn, error: error };

var parseApiOrigin = function (apiOrigin) {
    var host = new URL(apiOrigin);
    if (!host.protocol.match(/^https?:$/)) {
        throw new Error("http or https protocol must be used for bread API calls");
    }
    return host.origin;
};
var sleep = function (duration) { return new Promise(function (resolve) { return setTimeout(resolve, duration); }); };

var PolledFlag = /** @class */ (function () {
    function PolledFlag(name, interval, evaluationContext, client, logger, defaultValue) {
        this.active = true;
        this.name = name;
        this.interval = interval;
        this.evaluationContext = evaluationContext;
        this._result = defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
        this.client = client;
        this.logger = logger;
        this.poll();
    }
    Object.defineProperty(PolledFlag.prototype, "result", {
        get: function () {
            return this._result;
        },
        set: function (value) {
            if (value) {
                this._result = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    PolledFlag.prototype.disable = function () {
        this.active = false;
    };
    PolledFlag.prototype.poll = function () {
        var _this = this;
        if (this.active) {
            this.client
                .evaluate(this.name)
                .then(function (res) { return (_this.result = res); })
                .catch(function (e) { return _this.logger.error("error polling!", e); })
                .finally(function () { return sleep(_this.interval).then(_this.poll.bind(_this)); });
        }
    };
    return PolledFlag;
}());

var FeatureFlagClient = /** @class */ (function () {
    function FeatureFlagClient(config) {
        var _a;
        this.origin = parseApiOrigin(config.apiOrigin);
        this.logger = (_a = config.logger) !== null && _a !== void 0 ? _a : defaultLogger;
        this.clientSideId = config.clientSideId;
        this.evaluationContext = __assign({}, config.context);
        this.pollers = new Map();
    }
    /**
     * Evaluates a single flag and returns the result as a string.
     * Will reject if a network error is encountered and a finallyValue is not provided.
     * @param flagName - Name of feature flag to evaluate
     * @param [defaultValue] - Value to return if evaluation produces no results
     * @returns flag evaluation result on successful eval.  otherwise returns either the provided finallyValue or null.
     */
    FeatureFlagClient.prototype.evaluate = function (flagName, defaultValue) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, callEvaluate({
                                origin: this.origin,
                                body: this.evaluationContext,
                            }, this.logger, flagName)];
                    case 1:
                        result = _a.sent();
                        if (defaultValue) {
                            return [2 /*return*/, result !== null && result !== void 0 ? result : defaultValue];
                        }
                        else {
                            return [2 /*return*/, result];
                        }
                    case 2:
                        e_1 = _a.sent();
                        this.logger.error("Unexpected Error occurred while evaluating feature flag: ", flagName, "\n", e_1.toString());
                        if (defaultValue) {
                            return [2 /*return*/, Promise.resolve(defaultValue)];
                        }
                        else {
                            return [2 /*return*/, Promise.reject(e_1)];
                        }
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Evaluates all flags with the given context that are linked with the provided tag
     * @param options - filter params.  Bulk flag evaluation currently only supports a required filter on `tag`
     * @returns map of flag name : FlagResponse if evaluation was successful and returned results, otherwise returns an empty object
     */
    FeatureFlagClient.prototype.bulkEvaluate = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var tag, apiConfig, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tag = options.tag;
                        if (!tag) {
                            return [2 /*return*/, Promise.reject("Tag name is required")];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        apiConfig = {
                            origin: this.origin,
                            body: this.evaluationContext,
                        };
                        return [4 /*yield*/, callBulkEvaluate(apiConfig, this.logger, options)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_2 = _a.sent();
                        this.logger.error("Unexpected Error occurred during bulk evaluation", e_2.toString());
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Register a poller for a given flag with the current evaluation context
     * @param flagName - name of flag to poll
     * @param interval - how often to check for new results
     * @param defaultValue - return this value if poller does not find a result
     * @return true if poller registered, false if poller already exists
     */
    FeatureFlagClient.prototype.pollFlag = function (flagName, interval, defaultValue) {
        if (this.pollers.has(flagName)) {
            this.logger.error("Poller already exists for ".concat(flagName));
            return false;
        }
        var poller = new PolledFlag(flagName, interval, this.evaluationContext, this, this.logger, defaultValue !== null && defaultValue !== void 0 ? defaultValue : null);
        this.pollers.set(flagName, poller);
        return true;
    };
    /**
     * Get the latest evaluation result for polled flag
     * @param flagName - flag to check results on
     * @return most recent evaluation result
     */
    FeatureFlagClient.prototype.getLatestEvaluation = function (flagName) {
        var poller = this.pollers.get(flagName);
        if (poller) {
            return poller.result;
        }
        else {
            this.logger.error("Poller not registered for ".concat(flagName));
            return null;
        }
    };
    /**
     * Get a list of the currently registered pollers
     * @returns list of registered pollers
     */
    FeatureFlagClient.prototype.getPollers = function () {
        return Array.from(this.pollers.keys());
    };
    /**
     * Stop polling for a given flag, mostly for unit testing currently
     * @param flagName - name of flag to stop polling
     */
    FeatureFlagClient.prototype.stopPolling = function (flagName) {
        var poller = this.pollers.get(flagName);
        if (poller) {
            poller.disable();
            this.pollers.delete(flagName);
        }
        else {
            this.logger.error("Poller not registered for ".concat(flagName));
        }
    };
    return FeatureFlagClient;
}());

/**
 * Evaluates a single flag and returns the result as a string.
 * Will reject if a network error is encountered and a finallyValue is not provided.
 * @param config - FeatureFlag Client configuration necessary for API call
 * @param flagName - Name of feature flag to evaluate
 * @param [defaultValue] - Value to return if evaluation produces no results
 * @returns flag evaluation result on successful eval.  otherwise returns either the provided finallyValue or null.
 */
var evaluateFlag = function (config, flagName, defaultValue) { return __awaiter(void 0, void 0, void 0, function () {
    var logger, apiConfig, result, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                logger = (_a = config.logger) !== null && _a !== void 0 ? _a : defaultLogger;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                apiConfig = {
                    origin: parseApiOrigin(config.apiOrigin),
                    body: config.context,
                };
                return [4 /*yield*/, callEvaluate(apiConfig, logger, flagName)];
            case 2:
                result = _b.sent();
                if (defaultValue) {
                    return [2 /*return*/, result !== null && result !== void 0 ? result : defaultValue];
                }
                else {
                    return [2 /*return*/, result];
                }
            case 3:
                e_1 = _b.sent();
                logger.error("Unexpected Error occurred while evaluating feature flag: ", flagName, "\n", e_1.toString());
                return [2 /*return*/, defaultValue ? Promise.resolve(defaultValue) : Promise.reject(e_1)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Evaluates all flags with the given context that are linked with the provided tag
 * @param config - FeatureFlag Client configuration necessary for API call
 * @param options - filter params, currently only supports a required filter on `tag`
 * @returns map of flag name : FlagResponse if evaluation was successful and returned results, otherwise returns an empty object
 */
var bulkEvaluate = function (config, options) { return __awaiter(void 0, void 0, void 0, function () {
    var tag, logger, apiConfig, e_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                tag = options.tag;
                if (!tag) {
                    return [2 /*return*/, Promise.reject("Tag name is required")];
                }
                logger = (_a = config.logger) !== null && _a !== void 0 ? _a : defaultLogger;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                apiConfig = {
                    origin: parseApiOrigin(config.apiOrigin),
                    body: config.context,
                };
                return [4 /*yield*/, callBulkEvaluate(apiConfig, logger, options)];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                e_2 = _b.sent();
                logger.error("Unexpected Error occurred during bulk evaluation", e_2.toString());
                return [2 /*return*/, Promise.reject(e_2)];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { FeatureFlagClient, bulkEvaluate, evaluateFlag };
//# sourceMappingURL=index.mjs.map
